/**
 * BE/NL vlag componenten — SVG voor cross-browser betrouwbaarheid
 * (geen emoji-fonts: 🇧🇪 🇳🇱 renderen niet betrouwbaar op Windows / oude browsers).
 */

export function FlagBE({ className = "w-5 h-3.5 rounded-sm overflow-hidden inline-block" }) {
  return (
    <span className={className} aria-label="België">
      <svg viewBox="0 0 3 2" preserveAspectRatio="none" className="w-full h-full block">
        <rect width="1" height="2" x="0" fill="#000" />
        <rect width="1" height="2" x="1" fill="#FAE042" />
        <rect width="1" height="2" x="2" fill="#ED2939" />
      </svg>
    </span>
  );
}

export function FlagNL({ className = "w-5 h-3.5 rounded-sm overflow-hidden inline-block" }) {
  return (
    <span className={className} aria-label="Nederland">
      <svg viewBox="0 0 3 2" preserveAspectRatio="none" className="w-full h-full block">
        <rect width="3" height="0.667" y="0" fill="#AE1C28" />
        <rect width="3" height="0.667" y="0.667" fill="#fff" />
        <rect width="3" height="0.667" y="1.333" fill="#21468B" />
      </svg>
    </span>
  );
}

export function FlagsBENL({ size = "w-5 h-3.5" }) {
  return (
    <span className="inline-flex items-center gap-1.5 align-middle">
      <FlagBE className={`${size} rounded-sm overflow-hidden inline-block`} />
      <FlagNL className={`${size} rounded-sm overflow-hidden inline-block`} />
    </span>
  );
}
